import { put, call } from 'redux-saga/effects'
import { getCodingTest } from '../apiModules/codingTests'
import { codingTestEntities } from '../reducks'

export function* fetchCodingTestEntitySaga(candidateProfileId) {
  const response = yield call(getCodingTest, candidateProfileId)
  yield put(codingTestEntities.addItem(response.result.id, response.result))
  return response
}
